import styled from 'styled-components';
import {
    Alert,
    FormHelp,
} from '@zillow/constellation';

export const StyledFormHelp = styled(FormHelp)`
    font-weight: 600;
`;

export const StyledAlert = styled(Alert)`
    font-size: 14px;
`;
